var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpcenterIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fav_Icon_2",
    "data-name": "Fav Icon 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.894,
    height: 225.238,
    viewBox: "0 0 221.894 225.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M393.837,213.473c-6.021,0-10.437-4.416-10.437-10.036,0-6.423,4.416-10.437,10.437-10.437s10.036,4.416,10.036,10.437C403.873,208.656,399.457,213.072,393.837,213.473Zm49.778,18.466c-6.022,16.057-21.276,23.283-34.925,31.312,4.014-18.065,10.036-36.129,9.233-54.6-.4-5.62.4-11.642,6.824-13.649,4.817-1.606,12.043.4,16.057,3.613C449.637,205.445,446.826,222.706,443.615,231.939Z",
    transform: "translate(-224.833 -151.619)",
    fill: "#fafafa",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M421.815,197.437c-4.015-3.212-11.24-5.219-16.058-3.613-6.423,2.007-6.824,8.029-6.824,13.649.8,18.466-5.219,36.932-9.233,54.6,14.05-8.029,28.9-15.255,34.925-31.312C427.837,221.925,430.647,204.663,421.815,197.437Z",
    transform: "translate(-205.843 -150.837)",
    fill: "#fafafa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M393.837,192.9c-6.423,0-10.437,4.014-10.437,10.437,0,6.021,4.416,10.036,10.437,10.036a10.284,10.284,0,0,0,10.437-10.036A10.125,10.125,0,0,0,393.837,192.9Z",
    transform: "translate(-224.833 -151.92)",
    fill: "#fafafa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M397.291,254.073H371.2A28.537,28.537,0,0,1,343.9,233.6h0a29.031,29.031,0,0,0,27.7,20.473",
    transform: "translate(-343.9 -29.236)",
    fill: "#fafafa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M408.23,365.521l25.29-13.247c4.416-2.409,9.233-4.817,13.649-7.226,3.613-2.007,8.029-5.62,12.444-5.219-7.627,13.649-15.656,27.3-23.283,40.946h26.495l19.269-10.839c12.444-6.824,25.692-14.05,34.122-25.692,6.824-9.233,8.832-20.473,7.627-31.713-1.2-10.437-5.219-20.875-9.233-31.312L449.176,191.7c-2.409,3.211-4.416,6.824-6.423,10.036l-57.807,92.732C371.3,316.145,357.649,338.224,344,359.9c3.613,11.642,14.452,20.473,27.3,20.473h26.093a69.12,69.12,0,0,1,2.81-8.43C401.807,368.331,404.617,367.127,408.23,365.521Z",
    transform: "translate(-343.599 -155.537)",
    fill: "#fafafa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M410.645,243.342c-4.817-14.05,2.007-29.3,16.459-33.319,7.226-2.007,14.05,0,20.875,1.606,8.43,2.007,16.459,4.014,24.889,5.219a13.261,13.261,0,0,0,5.62,0c2.81-.4,3.211-.4,3.613-2.409.4-2.81-2.007-6.423-3.211-8.43a44.834,44.834,0,0,0-13.248-12.846c-10.839-7.627-24.487-10.839-37.735-10.437a64.7,64.7,0,0,0-37.735,13.649c-8.029,6.423-14.452,14.452-20.072,22.882l65.434,89.52-6.022-14.452C423.491,277.063,416.666,260.2,410.645,243.342Z",
    transform: "translate(-264.924 -182.692)",
    fill: "#fafafa"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpcenterIcon2);
export default __webpack_public_path__ + "static/media/helpcenter-Icon 2.084484def17f9c5475e2bd759bfa92f1.svg";
export { ForwardRef as ReactComponent };